import {Component, AfterViewInit, OnInit, ChangeDetectorRef, Input} from '@angular/core';
import {RoutingDemoPageService} from '../services/routing-demo-page-service';
import { marker } from 'leaflet/dist/leaflet.js';
import * as L from 'leaflet';
import {FormGroup} from '@angular/forms';
import 'leaflet/dist/leaflet.js';
import 'leaflet-spin/leaflet.spin';
import { closePopup } from 'leaflet/dist/leaflet.js';
import 'leaflet/dist/images/marker-icon-2x.png';
import 'leaflet/dist/images/marker-icon.png';
import 'leaflet/dist/images/marker-shadow.png';
import {SpinnerModule} from 'primeng/spinner';
import {ErrorDialogService} from '../services/error-dialog.service';
import {MainComponent} from '../main/main.component';


export enum timeUnits {
  Minutes = 'min',
  Hours = 'h'
}
export enum distanceUnits {
  Miles = 'mi',
  Kilometers = 'km'
}
export enum GEOMETERS  {
     '#996600',
     '#FF4500',
     '#006699',
     '#FF7F50',
     '#663300',
     '#00ffff',
     '#00008B',
     '#8B008B',
     '#8B0000',
     '#2d2d1f',
     '#00FF00',
     '#ffcc00',
     '#556B2F',
     '#0000ff',
     '#ff00bf'
}
export enum HistoricTrafficTimeBuckets  {
  None = 'none',
  'AM Peak'= 'ampeak',
  'PM Peak' = 'pmpeak',
  'Off Peak' = 'offpeak',
  'Night Time' = 'night'
}
export enum AmbientSpeedUnits  {
  MPH = 'mph',
  KPH = 'kph',
  MTPS = 'mtps',
  MTPM = 'mtpm'

}

@Component({
  selector: 'app-travel-boundary',
  templateUrl: './travel-boundary.component.html',
  styleUrls: ['./travel-boundary.component.css']
})
export class TravelBoundaryComponent implements OnInit, AfterViewInit {
  @Input() selectedDBName: string;
  @Input() username: string;
  @Input() password: string;
  private invalidcost: boolean;
  private invalidLong: boolean;
  private testlong: boolean;
  private testlat: boolean;
  private invalidLat: boolean;
  private bucketUnits: any[];
  private selectedHistoricTimeBucketB: any;
  private avoidTollRoads: boolean;
  private isMajorRoad: boolean;
  private returnHoles: boolean;
  private returnIslands: boolean;
  private MaxoffRoadDistance: any;
  private offRoadUnits: any[];
  private selectedOffRoadDistanceUnit: string;
  private testOffRoadDistance: boolean;
  private invalidoffRoadValue: boolean;
  private speedUnits: any[];
  private selectedAmbientSpeedUnit: any;
  private defaultAmbietSpeed: any;
  private testambientSpeed: boolean;
  private invalidambientSpeed: boolean;
  private simplificationFactor: number;
  private propagationFactor: number;
  private user: any;
  private userPasswod: any;
  constructor(private routingDemoPageService: RoutingDemoPageService, private ref: ChangeDetectorRef,
              private errorDialogService: ErrorDialogService) {

  }
  reg = new RegExp(/[~!@#$%^&*(\\\/\-['`;=+\]) "?:{}|<>_]/);
  longreg = new RegExp(/^-?(\d*\.)?\d*$/);
  latreg = new RegExp(/^-?(\d*\.)?\d*$/);
  offroaddistance = new RegExp(/[~!@#$%^&*(\\\/\-['`;=+\]), "?:{}|<>_]/);
  registerForm: FormGroup;
  map = this.routingDemoPageService.map;
  layerGroups = this.routingDemoPageService.layerGroup;
  boundaryType: string;
  selectedCostUnit: any;
  costUnits: any;
  pointX: any;
  pointY: any;
  coords: any;
  cost: any;
  appliedBoundary: boolean;
  isApplyButtonDisabled: boolean;
  isDisabled: boolean;
  bandingStyle = 'Donut';
  restRequest: string;
  boundaryForm: any;
  dataCleared: boolean;
  mapCleared: boolean;
  showReqDiv: boolean;
  private databases: any;
  private count = 0;
  private icon: { icon: any };
  ngOnInit() {
    this.map = this.routingDemoPageService.map;
    this.layerGroups = this.routingDemoPageService.layerGroup;
    this.showReqDiv = false;
    this.isMajorRoad = false;
    this.returnHoles = false;
    this.returnIslands = false;
    this.isDisabled = true;
    this.MaxoffRoadDistance = 60;
    this.defaultAmbietSpeed = 15;
    this.simplificationFactor = 0.5;
    this.propagationFactor = 0.16;
    this.boundaryType = 'time';
    this.assignCostUnits('time');
    this.historicbucket();
    this.maxOffRoadDistanceUnit();
    this.ambientSpeedUnits();
  }
  ngAfterViewInit() {
    this.setMapContentForBoundary();
  }
  validateCost() {
    this.invalidcost = this.reg.test(this.cost);
  }
  validateLongitude() {
    this.testlong = this.longreg.test(this.pointX);
    if (this.testlong === false) {
      this.invalidLong = this.testlong;
    } else {
      this.invalidLong = true;
    }
  }
  validateLatitude() {
    this.testlat = this.latreg.test(this.pointY);
    if (this.testlat === false) {
      this.invalidLat = this.testlat;
    } else {
      this.invalidLat = true;
    }
  }
  validateOffRoadDistance() {
    this.testOffRoadDistance = this.offroaddistance.test(this.MaxoffRoadDistance);
    if (this.testOffRoadDistance === false) {
      this.invalidoffRoadValue = this.testOffRoadDistance;
    } else {
      this.invalidoffRoadValue = true;
    }
  }
  validateAmbientSpeed() {
    this.testambientSpeed = this.offroaddistance.test(this.defaultAmbietSpeed);
    if (this.testambientSpeed === false) {
      this.invalidambientSpeed = this.testambientSpeed;
    } else {
      this.invalidambientSpeed = true;
    }
  }
  clearAll() {
    this.clearData();
    this.clearMap();
    this.isDisabled = true;
  }
  clearData() {
    this.ngOnInit();
    this.appliedBoundary = false;
    this.pointX = '';
    this.pointY = '';
    this.coords = '';
    this.cost = '';
    this.avoidTollRoads = false;
    this.MaxoffRoadDistance = 60 ;
    $('#donutStyle').addClass('active');
    $('#encompassingStyle').removeClass('active');
    $('#timeLabel').addClass('active');
    $('#distanceLabel').removeClass('active');
    this.isDisabled = true;
    this.dataCleared = true;
    if (this.dataCleared && this.mapCleared) {
      this.isDisabled = true;
    }
  }

  clearMap() {
    this.layerGroups.clearLayers();
    this.isDisabled = false;
    this.mapCleared = true;
    if (this.dataCleared && this.mapCleared) {
      this.isDisabled = true;
    }
  }

  setBoundaryType(value) {
    this.boundaryType = value;
    this.assignCostUnits(value);
  }

  assignCostUnits(value) {

    if (this.boundaryType === 'distance') {
      const arrayObjects = [];
      for (const [propertyKey, propertyValue] of Object.entries(distanceUnits)) {
        arrayObjects.push({ id: propertyValue, name: propertyKey });
      }
      this.costUnits = arrayObjects;
      this.selectedCostUnit =  this.costUnits[0].id;
    } else {
      const arrayObjects = [];
      for (const [propertyKey, propertyValue] of Object.entries(timeUnits)) {
        arrayObjects.push({ id: propertyValue, name: propertyKey });
      }
      this.costUnits = arrayObjects;
      this.selectedCostUnit =  this.costUnits[0].id;
    }
  }
  getTravelBoundary(isBoundaryFormValid) {
    this.appliedBoundary = true;
    if (isBoundaryFormValid) {
    const latitude = this.pointY;
    const longitude = this.pointX;
    const serviceURL = this.constructTravelBoundaryURL();
    this.map.spin(true);
    this.isApplyButtonDisabled = true;
    this.isDisabled = true;
    if (this.username) {

        this.user = this.username;
      }
    if (this.password) {

        this.userPasswod = this.password;
      }
    this.routingDemoPageService.executeService(serviceURL, this.user, this.userPasswod).subscribe((response) => {
      this.isDisabled = false;
      this.showReqDiv = true;
      const noOfColors = 15;
      const boundaryCostsCount = response.travelBoundary.costs.length;
      let geoJSONLayer;
      let index = 0;
      if (boundaryCostsCount > 1 && this.bandingStyle === 'Donut') {
          index = 1;
        }
      while (index < boundaryCostsCount ) {
          const geoJSONGeometry = response.travelBoundary.costs[index].geometry;
          geoJSONLayer = new L.geoJson(geoJSONGeometry);
          geoJSONLayer.setStyle({weight: 3.5});
          const rancor = GEOMETERS[Math.floor(Math.random() * noOfColors)];
          geoJSONLayer.setStyle({color: rancor});
          this.layerGroups.addLayer(geoJSONLayer);
          index++;
        }

      this.map.fitBounds(geoJSONLayer.getBounds(), {
          padding: [20, 20]
        });
      const boundaryPointLayer = marker([latitude, longitude]).addTo(this.map);
      this.layerGroups.addLayer(boundaryPointLayer);
      this.map.spin(false);
      this.isApplyButtonDisabled = false;
      this.isDisabled = false;
      this.routingDemoPageService.gotoElement('boundaryRestReq');
      this.count++;
      }, (errorRes) => {
        this.map.spin(false);
        this.isApplyButtonDisabled = false;
        this.isDisabled = false;
        if (!String.prototype.startsWith) {
          String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
          };
        }
        if (errorRes.error.value != null) {
          const errorMsg = errorRes.error.value;
          this.errorDialogService.showErrorDialog(errorMsg);
      } else if (errorRes.startsWith('<html>')) {
          this.errorDialogService.showErrorDialog('Invalid User Name or Password');
      }
      });
    }
  }

  constructTravelBoundaryURL() {
    let coords;
    if (this.coords) {
       coords = this.coords;
    } else {
       coords = this.coords = 'epsg:4326';
    }
    if (this.selectedDBName) {
      this.databases = this.selectedDBName;
    } else {
      this.databases = this.selectedDBName = 'Default';
    }
    const database = this.databases;
    const baseURL = this.routingDemoPageService.getBaseUrl();
    const inputCosts = this.cost;
    const costs = inputCosts.split(',');
    /*const costs = cost.toString().trim();*/
    const costsCount = costs.length;
    let costsString = '';
    let sortedCosts = '';
    if (costsCount > 1) {
      for (let i = 0; i < costsCount; i++) {
        for (let j = i + 1; j < costsCount; j++) {
          let tmp = 0;
          if (parseInt(costs[i]) > parseInt(costs[j])) {
            tmp = costs[i];
            costs[i] = costs[j];
            costs[j] = tmp;
          }
        }
      }
      for (let k = 0; k < costsCount; k++) {
        costsString += costs[k] + ' \, ';
      }
      costsString = costsString.slice(0, - 2);
      sortedCosts = costsString;
    } else {
      sortedCosts = inputCosts;
    }

    let url = '/databases/' + database + '.json?q=travelBoundary' +
      '&costs=' + sortedCosts +
      '&costUnit=' + this.selectedCostUnit +
      '&point=' + this.pointX + ',' + this.pointY + ',' + coords +
      '&majorRoads=' + this.isMajorRoad +
      '&bandingStyle=' + this.bandingStyle +
      '&returnHoles=' + this.returnHoles +
      '&simplificationFactor=' + this.simplificationFactor +
      '&propagationFactor=' + this.propagationFactor +
      '&returnIslands=' + this.returnIslands +
      '&historicTrafficTimeBucket=' + this.selectedHistoricTimeBucketB;
    if (this.avoidTollRoads) {
      url += '&avoid=tollRoad';
    }
    if (this.MaxoffRoadDistance === '') {
      this.MaxoffRoadDistance = 60;
    }
    if (isNaN(this.MaxoffRoadDistance)) {
      this.validateOffRoadDistance();
    } else {
      this.validateOffRoadDistance();
      url += '&maxOffroadDistance=' + this.MaxoffRoadDistance +
        '&maxOffroadDistanceUnit=' + this.selectedOffRoadDistanceUnit;
    }
    if (this.defaultAmbietSpeed === '') {
      this.defaultAmbietSpeed = 15;
    }
    if (isNaN(this.defaultAmbietSpeed)) {
      this.validateAmbientSpeed();
    } else {
      url += '&defaultAmbientSpeed=' + this.defaultAmbietSpeed +
        '&ambientSpeedUnit=' + this.selectedAmbientSpeedUnit;
    }

    this.restRequest = this.routingDemoPageService.serverAndPort(baseURL, url);
    return baseURL + url;
  }

  onChange(event: any) {
     const value = this.selectedCostUnit;
     this.selectedCostUnit = value;
  }
  setMapContentForBoundary() {
    this.map.closePopup();
    this.map.on('contextmenu')._events.contextmenu = [];
    this.map.on('contextmenu', (e) => {
      const x = e.latlng.lng;
      const y = e.latlng.lat;
      const scope = this;
      const boundaryRightClickText = $('<div/>').html('<div id="map-leaflet-popup"\n' +
        'class="map-popup" style="height: 20px; cursor: pointer;border: 0">Boundary Point</div>').contents().on('click', () => {
        scope.pointX = x.toFixed(6);
        scope.pointY = y.toFixed(6);
        this.validateLatitude();
        this.validateLongitude();
        this.ref.detectChanges();
        this.map.closePopup();
      })[0];
      L.popup().setLatLng(e.latlng).setContent(boundaryRightClickText).openOn(this.map);
    });
  }
  historicbucket() {

    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(HistoricTrafficTimeBuckets)) {
      arrayObjects.push({ id: propertyValue, name: propertyKey });
    }
    this.bucketUnits = arrayObjects;
    this.selectedHistoricTimeBucketB =  this.bucketUnits[0].id;

  }
  onChangeBucket(event: any) {
    const value = this.selectedHistoricTimeBucketB;
    this.selectedHistoricTimeBucketB = value;
  }

  setBandingStyle(value) {
    this.bandingStyle = value === 'Donut' ? 'Donut' : 'Encompassing';
  }
  maxOffRoadDistanceUnit() {
    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(distanceUnits)) {
      arrayObjects.push({ id: propertyValue, name: propertyKey });
    }
    this.offRoadUnits = arrayObjects;
    this.selectedOffRoadDistanceUnit =  this.offRoadUnits[0].id;
  }
  onChangeoffRoadUnits(event: any) {
    const value = this.selectedOffRoadDistanceUnit;
    this.selectedOffRoadDistanceUnit = value;
  }
  ambientSpeedUnits() {

    const arrayObjects = [];
    for (const [propertyKey, propertyValue] of Object.entries(AmbientSpeedUnits)) {
      arrayObjects.push({ id: propertyValue, name: propertyKey });
    }
    this.speedUnits = arrayObjects;
    this.selectedAmbientSpeedUnit =  this.speedUnits[0].id;

  }
  onChangeSpeedUnits(event: any) {
    const value = this.selectedAmbientSpeedUnit;
    this.selectedAmbientSpeedUnit = value;
  }
}
